import axios from "axios";
import queryString from "querystring";
import {parseTradeDetailsResponse, parseTradeListItemResponse} from "../utils";

export async function getTrades(params: { page: number, perPage?: number } = { page: 0 }): Promise<{ data: TradeListItemResponse[], pageCount: number }> {
	const perPage = params?.perPage ?? 50
	const page = params?.page ?? 0
	const _params = {
		limit: perPage,
		offset: page * perPage,
	};
	const { data: { data, metadata } } = await axios.get(`${process.env.NEXT_PUBLIC_MAYAN_EXPLORER_URL}/swaps?${queryString.stringify(_params)}`)
	return {
		data: data.map((d: any) => parseTradeListItemResponse(d)),
		pageCount: Math.ceil(metadata.count / perPage),
	};
}

export async function getTrade(inputHash: string | string[]): Promise<TradeDetailsResponse> {
	if(!inputHash) {
		return null;
	}
	const hash = Array.isArray(inputHash) ? inputHash[0] : inputHash;
	const res = await axios.get(`${process.env.NEXT_PUBLIC_MAYAN_EXPLORER_URL}/swap/order-id/${hash}`);
	return parseTradeDetailsResponse(res.data);
}

export async function getTraderHistory(trader: string , params: { page: number } = { page: 0 })
	: Promise<{ data: TradeDetailsResponse[], pageCount: number, volume: number, count: number }> {
	const perPage = 50
	const _params = {
		trader,
		limit: perPage,
		offset: params.page * perPage,
	};
	const { data: { data, metadata } } = await axios.get(`${process.env.NEXT_PUBLIC_MAYAN_EXPLORER_URL}/swaps/trader?${queryString.stringify(_params)}`)
	return {
		data: data.map((d) => parseTradeDetailsResponse(d)),
		pageCount: Math.ceil(metadata.count / perPage),
		volume: metadata.volume,
		count: metadata.count,
	};
}

export async function triggerTrade(inputTx: string | string[]) : Promise<TradeDetailsResponse> {
	if (!inputTx) {
		return null;
	}
	const transactionHash = Array.isArray(inputTx) ? inputTx[0] : inputTx;
	const { data } = await axios.post(`${process.env.NEXT_PUBLIC_MAYAN_EXPLORER_URL}/sync/trx/${transactionHash}`);
	return parseTradeDetailsResponse(data.swap);
}

export async function manualProgress(hash: string, password: string): Promise<any> {
	const body: { orderId?: string; sourceTxHash?: string; password: string } = { password };
	if (hash.startsWith('0x')) {
		body.sourceTxHash = hash;
	} else {
		body.orderId = hash;
	}
	const { data } = await axios.post('https://stuff.mayan.finance/manual-progress', body);
	return data;
}

export async function getStats(): Promise<Stats> {
	const { data } = await axios.get(`${process.env.NEXT_PUBLIC_MAYAN_EXPLORER_URL}/stats/overview`);
	return data;
}

export async function getMonthly(): Promise<MonthlyStats> {
	const { data } = await axios.get(`${process.env.NEXT_PUBLIC_MAYAN_EXPLORER_URL}/stats/monthly-overview`);
	return data;
}

type ApiChainName = Exclude<ChainName, 'aptos'>

export async function getSnakeys(range?: '24h' | '7d' | '30d'): Promise<{
	readonly [index in ApiChainName]: {
		readonly inFlow: readonly { chain: ApiChainName; volume: number }[];
		readonly outFlow: readonly { chain: ApiChainName; volume: number }[];
	};
}> {
	const params = {
		timeRange: range ?? '7d',
	};
	const { data } = await axios.get(
		`${process.env.NEXT_PUBLIC_MAYAN_EXPLORER_URL}/stats/chains-overview?${queryString.stringify(params)}`,
	);
	return data;
}

export async function getNFTItem(mint: string): Promise<NFTItem> {
	const { data } = await axios.get(`${process.env.NEXT_PUBLIC_MAYAN_PRICE_URL}/nft/item/${mint}`);
	return data;
}

export async function search(query: string): Promise<Array<SearchResponse>> {
	const { data } = await axios.get(`${process.env.NEXT_PUBLIC_MAYAN_EXPLORER_URL}/search?q=${query}`);
	return Array.isArray(data) ? data.slice(0, 1) : [];
}
